import React from 'react';
import { Toaster as SonnerToaster } from 'sonner';

/**
 * Latio toast host (DESIGN_SYSTEM.md §7/§8).
 * Success/error/indigo tones; supports Undo actions on reversible ops.
 * Mounted once at the app root.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        style: {
          borderRadius: 'var(--r-input)',
          border: '1px solid var(--latio-hairline)',
          boxShadow: 'var(--shadow-lg)',
          fontFamily:
            "'Product Sans', ui-rounded, 'Google Sans', system-ui, sans-serif",
        },
      }}
    />
  );
}
